import React, { useEffect, useState } from "react";
import { Mensaje } from "../mensajes";
import axios from "axios";

const ModalDocumentosDigitales = ({ disabled, id, files, setFiles }) => {
  const op = require("../../modulos/datos");
  const [msg, setMsg] = useState();
  const [mostrar, setMostrar] = useState(false);

  const buscarImagenes = () => {
    const nombresDocs = Object.keys(files);
    nombresDocs.forEach((nombre) => {
      const url = `${op.imagenreportes}/imagen_documento?id=${id}&img=${nombre}`;
      axios({
        url: url,
        method: "GET",
        responseType: "blob",
      })
        .then((response) => {
          const fileType = response.data.type;
          const file = new File([response.data], nombre, { type: fileType });
          handleFileChange(file, nombre);
        })
        .catch((error) => {
          console.error("Error al obtener la imagen:", error);
        });
    });
  };

  const handleFileChange = (file, name) => {
    if (!file) return;

    const MAX_SIZE = 5 * 1024 * 1024;

    if (file.size > MAX_SIZE) {
      setMsg(`El archivo "${file.name}" es demasiado grande. Máximo 5MB.`);
      setFiles((prev) => ({
        ...prev,
        [name]: { ...prev[name], file: null, preview: null, error: true },
      }));
      setMostrar(true);
      return;
    }

    const previewUrl = URL.createObjectURL(file);
    setFiles((prev) => ({
      ...prev,
      [name]: {
        ...prev[name],
        file: file,
        preview: previewUrl,
        error: false,
      },
    }));
  };

  const handleRemoveFile = (name) => {
    if (files[name]?.preview) {
      URL.revokeObjectURL(files[name].preview);
    }

    setFiles((prev) => ({
      ...prev,
      [name]: {
        file: null,
        preview: null,
        error: false,
      },
    }));
  };

  useEffect(() => {
    if (id) {
      buscarImagenes();
    }
  }, [id]);

  const FileBox = ({ id, label, fileData }) => {
    const { preview, file, error } = fileData || {};
    const hasFile = !!file;

    return (
      <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6 d-flex flex-column align-items-center mb-4">
        <div
          className={`file-box-container ${hasFile ? "has-file" : "is-empty"} ${error ? "has-error" : ""} ${disabled ? "is-disabled" : ""}`}
          style={{
            height: "110px",
            width: "120px",
            position: "relative",
          }}
        >
          {/* BOTÓN X */}
          {hasFile && !disabled && (
            <button
              type="button"
              onClick={(e) => {
                e.preventDefault();
                handleRemoveFile(id);
              }}
              className="remove-btn"
              title="Eliminar archivo"
            >
              <i className="fa fa-times"></i>
            </button>
          )}

          {/* Input invisible */}
          <input
            type="file"
            id={id}
            disabled={disabled}
            className="input-overlay"
            style={{ cursor: disabled ? "not-allowed" : "pointer" }}
            onChange={(e) => handleFileChange(e.target.files[0], id)}
          />

          {/* Contenido Visual */}
          <div className="content-wrapper">
            {preview ? (
              hasFile && file?.type?.includes("image") ? (
                <img src={preview} alt="Vista" className="preview-img" />
              ) : (
                <div className="pdf-preview text-center">
                  <i className="fa fa-file-pdf fa-2x text-danger"></i>
                  <span className="d-block small mt-1 fw-bold text-muted">
                    PDF
                  </span>
                </div>
              )
            ) : (
              <div className="upload-placeholder">
                <div className="icon-circle">
                  <i className="fa fa-cloud-upload-alt"></i>
                </div>
                <span className="upload-text">SUBIR</span>
              </div>
            )}
          </div>
        </div>

        <label htmlFor={id} className="file-label mt-2 px-1 text-center">
          {label}
        </label>
      </div>
    );
  };

  return (
    <>
      <style>
        {`
          .file-box-container {
            border: 2px dashed #cbd5e0;
            border-radius: 12px;
            background-color: #f7fafc;
            transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
            display: flex;
            align-items: center;
            justify-content: center;
            overflow: visible;
          }

          .file-box-container.is-empty:not(.is-disabled):hover {
            border-color: #4299e1;
            background-color: #ebf8ff;
            transform: translateY(-3px);
            box-shadow: 0 4px 12px rgba(66, 153, 225, 0.15);
          }

          .file-box-container.has-file {
            border: 2px solid #48bb78;
            background-color: #ffffff;
            border-style: solid;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
          }

          .file-box-container.has-error {
            border-color: #f56565;
            background-color: #fff5f5;
          }

          .file-box-container.is-disabled {
            opacity: 0.6;
            background-color: #edf2f7;
            border-color: #a0aec0;
          }

          .input-overlay {
            position: absolute;
            top: 0; left: 0; width: 100%; height: 100%;
            opacity: 0;
            z-index: 10;
          }

          .content-wrapper {
            width: 100%; height: 100%;
            display: flex; align-items: center; justify-content: center;
            padding: 8px;
          }

          .preview-img {
            max-width: 100%; max-height: 100%;
            object-fit: contain;
            border-radius: 6px;
          }

          .icon-circle {
            width: 36px; height: 36px;
            background: #edf2f7;
            border-radius: 50%;
            display: flex; align-items: center; justify-content: center;
            margin: 0 auto 6px;
            transition: all 0.3s ease;
            color: #718096;
          }

          .file-box-container.is-empty:not(.is-disabled):hover .icon-circle {
            background: #4299e1;
            color: white;
          }

          .upload-text {
            font-size: 0.65rem;
            font-weight: 800;
            letter-spacing: 0.8px;
            color: #a0aec0;
          }

          .remove-btn {
            position: absolute;
            top: -8px; right: -8px;
            z-index: 30;
            width: 22px; height: 22px;
            border-radius: 50%;
            background: #f56565;
            color: white;
            border: 2px solid white;
            display: flex; align-items: center; justify-content: center;
            font-size: 9px;
            box-shadow: 0 2px 5px rgba(0,0,0,0.2);
            transition: all 0.2s;
            cursor: pointer;
          }

          .remove-btn:hover { transform: scale(1.15); background: #e53e3e; }

          .file-label {
            font-size: 0.65rem;
            font-weight: 700;
            color: #4a5568;
            text-transform: uppercase;
            line-height: 1.2;
            width: 100%;
            max-width: 130px;
          }

          input[type="file"]::-webkit-file-upload-button { display: none; }
        `}
      </style>

      <div className="container-fluid py-4">
        {/* Usamos row-cols para controlar cuántos elementos hay por fila y g-4 para espacio lateral */}
        <div className="row g-4 justify-content-center">
          <FileBox
            id="registroMercantil"
            label="Registro Mercantil"
            fileData={files.registroMercantil}
          />
          <FileBox id="balance" label="Balance Gral" fileData={files.balance} />
          <FileBox
            id="servicioNacional"
            label="Servicio Nac. Contratista"
            fileData={files.servicioNacional}
          />
          <FileBox
            id="cedula"
            label="Cédula Representante"
            fileData={files.cedula}
          />
          <FileBox
            id="sunacoop"
            label="Constancia Sunacoop"
            fileData={files.sunacoop}
          />
          <FileBox
            id="planillaIsrl"
            label="Planilla ISLR"
            fileData={files.planillaIsrl}
          />
          <FileBox id="rif" label="RIF Actualizado" fileData={files.rif} />
          <FileBox
            id="solvenciaIvss"
            label="Solvencia IVSS"
            fileData={files.solvenciaIvss}
          />
          <FileBox
            id="solvenciaInces"
            label="Solvencia INCES"
            fileData={files.solvenciaInces}
          />
          <FileBox
            id="solvenciaLaboral"
            label="Solvencia Laboral"
            fileData={files.solvenciaLaboral}
          />
          <FileBox
            id="solvenciaMunicipal"
            label="Solvencia Municipal"
            fileData={files.solvenciaMunicipal}
          />
        </div>

        <Mensaje
          titulo="Notificación"
          mensaje={msg}
          show={mostrar}
          onHide={() => setMostrar(false)}
        />
      </div>
    </>
  );
};

export default ModalDocumentosDigitales;
